import { ColDef } from 'ag-grid-community';
import { useIntl } from 'react-intl';
import { Tabs, RIGHT_ALIGNED, RIGHT_ALIGNED_STYLES } from 'common/constants';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { getNumberFromCurrency } from 'pages/VendorsTablePage/components/VendorsTable/helpers';
import { useAppSelector } from 'store/hooks';
import { formatCurrency } from 'utils/formatCurrency';
import { TEXT_RENDERER_STYLES } from '../constants';
import { gridColumnLabelMessages } from '../messages';
import { AuthorizationPaymentRecordType } from '../types';
import { InvoicesTextRenderer } from './InvoiceTextRenderer';

export const useInvoiceColumns = (): ColDef[] => {
  const selectedTab = useAppSelector(getSelectedTab);
  const intl = useIntl();
  return [
    {
      field: 'vendorNo',
      headerName: intl.formatMessage(gridColumnLabelMessages.vendorNoLabel),
      minWidth: 150
    },

    {
      field: 'vendorName',
      headerName: intl.formatMessage(gridColumnLabelMessages.vendorNameLabel),
      minWidth: 50,
      width: 300
    },
    {
      field: 'invoiceId',
      headerName: intl.formatMessage(gridColumnLabelMessages.invoiceIdLabel),
      minWidth: 50,
      width: 300
    },
    ...(selectedTab === Tabs.ToBePaid
      ? [
          {
            field: 'paymentMethod',
            headerName: intl.formatMessage(
              gridColumnLabelMessages.paymentMethodLabel
            ),
            minWidth: 50,
            width: 300
          }
        ]
      : []),
    {
      field: 'netAmount',
      headerName: intl.formatMessage(gridColumnLabelMessages.netAmountLabel),
      minWidth: 50,
      width: 280,
      type: RIGHT_ALIGNED,
      cellStyle: RIGHT_ALIGNED_STYLES,
      valueGetter: ({ data }: { data: AuthorizationPaymentRecordType }) =>
        formatCurrency(getNumberFromCurrency(data?.netAmount), 'decimal')
    },
    {
      field: 'invoiceDescription',
      headerName: intl.formatMessage(gridColumnLabelMessages.invoiceDescLabel),
      minWidth: 50,
      width: 400,
      cellRenderer: InvoicesTextRenderer,
      sortable: false,
      cellStyle: TEXT_RENDERER_STYLES
    }
  ];
};
